import React from "react";
import PageTitle from "../PageTitle";
import { doRequest, dovocalRequest } from "../../helper";
import $, { valHooks } from "jquery";
import { NavLink } from "react-router-dom";
import LazyLoad from "react-lazyload";
import axios from "axios";
import { saveAs } from "file-saver";
import DetailPopup from "./DetailPopup";
let newevent = [
  "sashaktnari",
  "swachhbharat",
  "promotingincredibleindia",
  "vocalforlocal",
  "digitalpayment",
];

export default class VbActivityModeration extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      response: null,
      postCount: 0,
      status: "",
      activity: "",
      points: "manual",
      // lastEvaluatedKey: "",
      loadMoreDisplay: false,
      selectedPhotos: [],
      isChecked: false,
      limit: 100,
      page: 1,
      selectedButton: null,
      showDetailPopup: false,
      popupImageUrl: "",
      postDetail: {},
      selectedPostActivity: "",
    };
    this.update = this.update.bind(this);
    this.getGallerydata = this.getGallerydata.bind(this);
    this.selectToggle = this.selectToggle.bind(this);
  }

  getSelfieDetail = async (id, activi_key) => {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    let response = await fetch(
      `https://d1zez9d7l5hgkm.cloudfront.net/v1/post/aidetail?id=${id}&activity_key=${activi_key}&v=${Math.random()}`,
      requestOptions
    );

    let result = await response.json();
    if (result.resultFlag === 1 || result.resultFlag === "1") {
      this.setState({
        postDetail: result.response,
      });
    }
  };

  handleShowDetailPopup = async (showhide, imgurl, post_id, activi_key) => {
    $("body").css({ overflow: "hidden" });
    await this.getSelfieDetail(post_id, activi_key);
    this.setState({
      showDetailPopup: showhide,
      popupImageUrl: imgurl,
      selectedPostActivity: activi_key,
    });
  };

  closeDetailPopup = () => {
    $("body").css({ overflow: "auto" });
    this.setState({
      showDetailPopup: false,
    });
  };
  componentDidMount() {
    var status = this.props.match.params.status;
    if (!status) {
      status = "manual";
    }
    this.getGallerydata(
      "loadmore",
      this.state.page,
      status,
      this.state.activity
    );
  }

  getGallerydata(loadmore, pageno, status, point, activity) {
    $("#loader").css({ display: "block" });
    var ref = this;
    ref.setState({
      status: status,
    });
    ref.setState({
      activity: activity,
    });
    if (point == "manual") {
      ref.setState({
        points: "manual",
      });
    }
    if (point == "disable") {
      ref.setState({
        points: "rejected",
      });
    }
    if (point == "enable") {
      ref.setState({
        points: "processed",
      });
    }
    if (!loadmore) {
      ref.setState({ items: [], page: 1 });
    }
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };
    fetch(
      `https://d1zez9d7l5hgkm.cloudfront.net/v1/moderation/postlilst?page=${
        pageno ? pageno : this.state.page
      }&limit=${this.state.limit}&status=${status}&activity_key=${
        activity ? activity : ""
      }&v=${Math.random()}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (
          result &&
          result["resultFlag"] == "1" &&
          result["resultFlag"] == 1
        ) {
          if (status == "rejected") {
            if (loadmore) {
              ref.setState(
                {
                  items: [...ref.state.items, ...result.response],
                },
                () => {
                  $("#loader").css({ display: "none" });
                }
              );
            } else {
              ref.setState(
                {
                  items: [...result.response],
                },
                () => {
                  $("#loader").css({ display: "none" });
                }
              );
            }
          } else {
            ref.setState(
              {
                items: [...ref.state.items, ...result.response],
              },
              () => {
                $("#loader").css({ display: "none" });
              }
            );
          }
          if (result.response.length.toString() >= this.state.limit) {
            ref.setState({
              loadMoreDisplay: true,
            });
          } else {
            ref.setState({
              loadMoreDisplay: false,
            });
          }
        }
      })
      .catch((error) => console.log("error", error));
  }

  update(id, status) {
    let confirm = window.confirm(
      "Are you sure you want to approve this image ?"
    );
    if (confirm) {
      var ref = this;
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        id: id,
        status: status,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
      fetch(
        "https://d1zez9d7l5hgkm.cloudfront.net/v1/post/update",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          console.l;
          if (result && result["resultFlag"] == 1) {
            $("#post_" + id).hide();
          }
        })
        .catch((error) => console.log("error", error));
    }
    // $("#loader").css({ display: "block" });
  }

  rejectupdate(id, status) {
    let confirm = window.confirm(
      "Are you sure you want to reject this image ?"
    );
    if (confirm) {
      var ref = this;
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        id: id,
        status: status,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
      fetch(
        "https://d1zez9d7l5hgkm.cloudfront.net/v1/post/update",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          console.l;
          if (result && result["resultFlag"] == 1) {
            $("#post_" + id).hide();
          }
        })
        .catch((error) => console.log("error", error));
    }
    // $("#loader").css({ display: "block" });
  }

  loadMoreData = () => {
    this.setState({
      page: this.state.page + 1,
    });
    $("#loader").css({ display: "block" });
    this.getGallerydata(
      "loadmore",
      this.state.page + 1,
      this.state.status,
      this.state.activity
    );
    $("#loader").css({ display: "none" });
  };

  selectToggle() {
    if ($(".allChecked").length > 0) {
      $(".multi_select").prop("checked", false);
      $(".multi_select").removeClass("allChecked");
    } else {
      $(".multi_select").prop("checked", true);
      $(".multi_select").addClass("allChecked");
    }
  }

  UnselectChekbox = () => {
    this.setState({ selectedPhotos: [] });
  };

  render() {
    var bread = "VbAcitivity / Moderation (Disabled Posts)";
    var pagelink = "/viksitbharatselfie/moderation";
    if (this.state.status == "rejected") {
      bread = "VbAcitivity/ Moderation (Disabled Posts)";
      pagelink += "/disabled";
    } else if (this.state.status == "processed") {
      bread = "VbAcitivity/ Moderation (Enabled Posts)";
      pagelink += "/enabled";
    } else {
      bread = "VbAcitivity/ Moderation (Enabled Posts)";
      pagelink += "/disabled";
    }
    var items = this.state.items;
    var links = [
      {
        link: "/vbactivity/moderation/disabled",
        name: "View Disabled Posts",
      },
      {
        link: "/vbactivity/moderation/enabled",
        name: "View Active Posts",
      },
    ];
    var pagination = [];
    if (this.state.response && countdata) {
      var countdata = this.state.response.countdata;
      var pages = Math.ceil(countdata.Count / this.state.limit);

      for (var i = 1; i <= pages; i++) {
        pagination.push(
          <span key={i}>
            <NavLink to={pagelink + "/" + i} className="btn btn-primary btn-xs">
              {i}
            </NavLink>
            &nbsp;
          </span>
        );
      }
    }

    const { selectedPhotos } = this.state;
    const { isChecked } = this.state;
    return (
      <div>
        <PageTitle
          title="#VbAcitivity"
          bread={bread}
          //   links={links}
          Count={this.state.postCount}
        />
        <div className="wrapper wrapper-content">
          <br />
          <div className="form-inline form_right">
            <div>
              <select
                id="state"
                name="state"
                className="form-control rigt_mar"
                onChange={(e) =>
                  this.getGallerydata(
                    "",
                    1,
                    this.state.status,
                    this.state.points,
                    e.target.value
                  )
                }
                value={this.state.activity}
              >
                <option value="">Select Your Activity</option>
                {Array.isArray(newevent) &&
                  newevent.map((val, i) => {
                    return (
                      <option value={val} key={i}>
                        {val}
                      </option>
                    );
                  })}
              </select>
              <button
                className={
                  this.state.points === "manual"
                    ? `btn btn-success btn-rounded`
                    : `btn btn-primary btn-rounded`
                }
                onClick={() =>
                  this.getGallerydata(
                    "",
                    1,
                    "manual",
                    "manual",
                    this.state.activity
                  )
                }
              >
                Under Moderation
              </button>
              <button
                className={
                  this.state.points === "processed"
                    ? `btn btn-success btn-rounded`
                    : `btn btn-primary btn-rounded`
                }
                onClick={() =>
                  this.getGallerydata(
                    "",
                    1,
                    "processed",
                    "enable",
                    this.state.activity
                  )
                }
              >
                Approved
              </button>
              <button
                className={
                  this.state.points === "rejected"
                    ? `btn btn-success btn-rounded`
                    : `btn btn-primary btn-rounded`
                }
                onClick={() =>
                  this.getGallerydata(
                    "",
                    1,
                    "rejected",
                    "disable",
                    this.state.activity
                  )
                }
              >
                Rejected
              </button>
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-lg-12">
              <div className="kamal_list">
                <p
                  id="nodatafound"
                  style={{
                    display: "none",
                    textAlign: "center",
                    position: "relative",
                    left: "50%",
                    transform: "translateX(-50%)",
                  }}
                >
                  No Data Found
                </p>
                {Array.isArray(items) &&
                  items.map((value, index) => {
                    return (
                      <div class="file-box" key={index} id={"post_" + value.id}>
                        <div class="file">
                          <a href="javascript:void(0);">
                            <span class="corner"></span>
                            <LazyLoad>
                              <div class="image" style={{ height: "auto" }}>
                                <div
                                  onClick={() => {
                                    this.handleShowDetailPopup(
                                      true,
                                      value.image_path,
                                      value.id,
                                      value.activity_key
                                    );
                                  }}
                                  className="user_image_list"
                                >
                                  <ul>
                                    <li>
                                      <a>
                                        <img src={value.image_path} alt="" />
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <div className="image_caption vbactivity">
                                  {value.status == "manual" && (
                                    <a
                                      href="javascript:void(0);"
                                      className="btn btn-primary btn-circle"
                                      onClick={() => {
                                        this.update(value.id, "processed");
                                      }}
                                      type="button"
                                      title="approved"
                                    >
                                      <i className="fa fa-check"></i>
                                    </a>
                                  )}
                                  {value.status == "manual" && (
                                    <a
                                      href="javascript:void(0);"
                                      className="btn btn-warning btn-circle"
                                      onClick={() => {
                                        this.rejectupdate(value.id, "rejected");
                                      }}
                                      type="button"
                                      title="rejected"
                                    >
                                      <i className="fa fa-times"></i>
                                    </a>
                                  )}
                                </div>
                              </div>
                            </LazyLoad>
                            <div class="file-name">
                              {value.activity_name ? value.activity_name : ""}
                              <br />

                              <small>
                                Added:{" "}
                                {value.created_at ? value.created_at : ""}
                              </small>
                            </div>
                          </a>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
            {this.state.loadMoreDisplay && (
              <button
                style={{
                  position: "relative",
                  left: "50%",
                  transform: "translateX(-50%)",
                  padding: "10px 18px",
                }}
                type="button"
                onClick={this.loadMoreData}
              >
                Load More
              </button>
            )}
          </div>
        </div>

        {this.state.showDetailPopup && (
          <DetailPopup
            image_url={this.state.popupImageUrl}
            close={this.closeDetailPopup}
            detail={this.state.postDetail}
            selectedPostActivity={this.state.selectedPostActivity}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Vbactivity/Moderation.jsx